export const eventConstants = {
    GET_REQUEST: 'EVENT_GET_REQUEST',
    GET_ALL_REQUEST: 'EVENT_GET_ALL_REQUEST',
    EDIT_REQUEST: 'EVENT_EDIT_REQUEST',
    DELETE_REQUEST: 'EVENT_DELETE_REQUEST',
    LOADING_REQUEST: 'EVENT_LOADING_REQUEST',

    CREATE_EVENT_TARGET: 'CREATE_EVENT_TARGET_REQUEST',
    RESET_EVENT_TARGET: 'RESET_EVENT_TARGET_VALUE',
};